export default __webpack_public_path__ + "static/big_event-787671a0b9368068cde59b7f25e204ff.webp";